
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/referral",
      function () {
        return require("private-next-pages/settings/referral.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/referral"])
      });
    }
  